<template>
  <v-btn
    v-if="isNewer"
    @click="updateVersion"
    v-bind="$props"
    v-on="$listeners"
    data-cy="Aurora-UpdateButton"
  >
    Update Available
  </v-btn>
</template>

<script>
import { VBtn } from 'vuetify/lib';
import axios from 'axios';
import VersionCompare from '../VersionCompare';

export default {
  name: 'UpdateButton',
  extends: VBtn,
  props: {
    version: {
      type: String,
      default: '0.0.0',
    },
  },
  data: () => ({
    packageVersion: 0,
    apiVersion: '0.0.0',
  }),
  computed: {
    isNewer() {
      const { version, apiVersion } = this;
      const versionCompare = new VersionCompare(apiVersion, version);
      return versionCompare.isNewer();
    },
  },
  async mounted() {
    await this.refresh();
    this.interval = setInterval(() => {
      this.refresh();
    }, 15000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    async refresh() {
      const { data } = await axios.get('/api/client/version');
      this.apiVersion = data.version;
    },
    async updateVersion() {
      const res = await this.$confirm('Are you sure you want to update?');
      if (res) {
        if ('serviceWorker' in navigator) {
          const registration = await navigator.serviceWorker.getRegistration();
          if (registration) {
            registration.waiting.postMessage({ type: 'SKIP_WAITING' });
            registration.waiting.addEventListener('statechange', (event) => {
              if (event.target.state === 'activated') {
                registration.waiting.postMessage({ type: 'CLIENTS_CLAIM' });
                window.location.reload();
              }
            });
          } else {
            window.location.reload();
          }
        } else {
          window.location.reload();
        }
      }
    },
    compare() {
      return VersionCompare.compare(this.packageVersion, this.apiVersion);
    },
  },
};
</script>
